import { match } from "ts-pattern";
import {
  ControlDataTypeKey,
  Types
} from "../prop-controllers";
import { LinkDefinition } from "@makeswift/controls";
import { z } from "zod";
const linkDataSchema = LinkDefinition.schema.link;
const linkPropControllerDataV0Schema = linkDataSchema;
const LinkPropControllerDataV1Type = "prop-controllers::link::v1";
const linkPropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(LinkPropControllerDataV1Type),
  value: linkDataSchema
});
const linkPropControllerDataSchema = z.union([
  linkPropControllerDataV0Schema,
  linkPropControllerDataV1Schema
]);
function Link(options = {}) {
  return { type: Types.Link, version: 1, options };
}
function getLinkPropControllerDataLinkData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: LinkPropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createLinkPropControllerDataFromLinkData(value, definition) {
  return match(definition).with(
    { version: 1 },
    () => ({
      [ControlDataTypeKey]: LinkPropControllerDataV1Type,
      value
    })
  ).otherwise(() => value);
}
function getLinkPropControllerPageIds(linkData) {
  if (linkData == null)
    return [];
  const link = getLinkPropControllerDataLinkData(linkData);
  switch (link.type) {
    case "OPEN_PAGE":
      return link.payload.pageId == null ? [] : [link.payload.pageId];
    default:
      return [];
  }
}
function copyLinkData(data, context) {
  let value = data;
  switch (value?.type) {
    case "OPEN_PAGE":
      {
        const pageId = value.payload.pageId;
        if (pageId == null)
          return value;
        value = {
          ...value,
          payload: {
            ...value.payload,
            pageId: context.replacementContext.pageIds.get(pageId) ?? pageId
          }
        };
      }
      break;
    case "SCROLL_TO_ELEMENT": {
      const elementIdConfig = value.payload.elementIdConfig;
      if (elementIdConfig == null)
        return value;
      value = {
        ...value,
        payload: {
          ...value.payload,
          elementIdConfig: {
            ...elementIdConfig,
            elementKey: context.replacementContext.elementKeys.get(
              elementIdConfig.elementKey
            ) ?? elementIdConfig.elementKey
          }
        }
      };
      break;
    }
  }
  return value;
}
function copyLinkPropControllerData(data, context) {
  if (data == null)
    return data;
  const value = copyLinkData(getLinkPropControllerDataLinkData(data), context);
  if (value == null)
    return value;
  return match(data).with({ [ControlDataTypeKey]: LinkPropControllerDataV1Type }, (v1) => ({
    ...v1,
    value
  })).otherwise((_) => value);
}
export {
  Link,
  LinkPropControllerDataV1Type,
  copyLinkData,
  copyLinkPropControllerData,
  createLinkPropControllerDataFromLinkData,
  getLinkPropControllerDataLinkData,
  getLinkPropControllerPageIds,
  linkDataSchema,
  linkPropControllerDataSchema
};
//# sourceMappingURL=link.js.map